import script from "./historial.vue?vue&type=script&setup=true&lang=js"
export * from "./historial.vue?vue&type=script&setup=true&lang=js"

import "./historial.vue?vue&type=style&index=0&id=4ca120ee&lang=css"

const __exports__ = script;

export default __exports__